import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import cookie from '@/components/cookie'
import findPwdAccount from '@/components/findPwdAccount'
// ET
import ListView from '@/components/Et/ListView'
import TimeView from '@/components/Et/TimeView'
import FolderView from '@/components/Et/FolderView'
import PdfView from '@/components/Et/PdfView'
import RootFolder from '@/components/Et/RootFolder'
import SubFolder from '@/components/Et/SubFolder'
// 笔记本
import NoteListView from '@/components/Notebook/ListView'
import NotebookView from '@/components/Notebook/NotebookView'
import Books from '@/components/Notebook/Books'
import Notes from '@/components/Notebook/Notes'
import TagView from '@/components/Notebook/TagView'
import Tags from '@/components/Notebook/Tags'
import TagDetail from '@/components/Notebook/TagDetail'
import Pdf from '@/components/Notebook/Pdf'
// ET分享查看
import ShareCheck from '@/components/Et/ShareCheck'
import ShareList from '@/components/Et/ShareList'
// notebook分享查看
import NoteShareCheck from '@/components/Notebook/ShareCheck'
import NoteShareListView from '@/components/Notebook/ShareListView'
import NoteShareList from '@/components/Notebook/ShareList'
import NoteShareListDetail from '@/components/Notebook/ShareListDetail'
import NoteShareFiles from '@/components/Notebook/ShareFiles'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/cookie',
      component: cookie
    },
    {
      path: '/findPwdAccount',
      component: findPwdAccount
    },
    {
      path: '/et',
      component: ListView,
      children: [
        {
          path: '',
          component: TimeView
        },
        {
          path: 'time',
          component: TimeView
        },
        {
          path: 'folder',
          component: FolderView,
          children: [
            {
              path: '',
              component: RootFolder
            },
            {
              path: ':id/:name',
              component: SubFolder
            }
          ]
        },
        {
          path: 'pdf',
          component: PdfView
        }
      ]
    },
    {
      path: '/notebook',
      component: NoteListView,
      children: [
        {
          path: '',
          component: NotebookView,
          children: [
            {
              path: '',
              component: Books
            },
            {
              path: 'book',
              component: Books
            },
            {
              path: 'notes',
              component: Notes
            }
          ]
        },
        {
          path: 'notebook',
          component: NotebookView,
          children: [
            {
              path: '',
              component: Books
            },
            {
              path: 'books',
              component: Books
            },
            {
              path: 'notes',
              component: Notes
            }
          ]
        },
        {
          path: 'tag',
          component: TagView,
          children: [
            {
              path: '',
              component: Tags
            },
            {
              path: 'tags',
              component: Tags
            },
            {
              path: 'tagDetail',
              component: TagDetail
            }
          ]
        },
        {
          path: 'pdf',
          component: Pdf
        }
      ]
    },
    {
      path: '/share/:shareId',
      component: ShareCheck
    },
    {
      path: '/share/:shareId/list',
      component: ShareList
    },
    {
      path: '/share/et/:shareId',
      component: ShareCheck
    },
    {
      path: '/share/et/:shareId/list',
      component: ShareList
    },
    {
      path: '/share/book/:shareId',
      component: NoteShareCheck
    },
    {
      path: '/share/book/:shareId/list',
      component: NoteShareListView,
      children: [
        {
          path: '',
          component: NoteShareList
        },
        {
          path: 'folder',
          component: NoteShareList
        },
        {
          path: 'detail',
          component: NoteShareListDetail
        }
      ]
    },
    {
      path: '/share/book/:shareId/files',
      component: NoteShareFiles
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js